import * as React from 'react'

import { Card } from '@grandvisionhq/common'
import { useIntl } from '@grandvisionhq/state'

import { SummaryProps } from '../types'

const AddressSummary = ({ actions, values = {} }: SummaryProps) => {
  const { getLabel } = useIntl()

  return (
    <Card>
      <Card.Content>
        {actions?.onEdit && (
          <Card.Actions>
            <Card.Button onClick={actions.onEdit} children={getLabel('common.actions.edit')} />
          </Card.Actions>
        )}
        <Card.Text variant="body-head">
          {values.firstName} {values.lastName}
        </Card.Text>
        <Card.Text>{values.additionalAddressInfo}</Card.Text>
        <Card.Text>
          {values.streetName} {values.streetNumber} {values.additionalStreetInfo}
        </Card.Text>
      </Card.Content>
    </Card>
  )
}

export default AddressSummary
